const TermsAndConditions = () => {
  return (
    <div className="flex flex-col justify-center w-full items-center ">
      <div className="flex flex-col justify-center items-start max-w-screen-lg gap-2 p-8">
        <h2 className="font-medium text-xl">Definitions</h2>
        For the purposes of these Terms and Conditions: Authors refers to the
        publishers of the Application and Services. Application means the
        software program provided by the Author(s) downloaded by You on any
        electronic device, named Pittsburgh2Peers Site refers to
        www.pittsburgh2peers.vercel.app/ Device means any device that can access
        the Application or Service such as a computer or a digital tablet.
        Service refers to the Application, the Site and contents generated by
        the Authors to facilitate the use of the Application. You means the
        individual accessing or using the Application/Service, or the company,
        or other legal entity on behalf of which such individual is accessing or
        using the Application/Service, as applicable.
        <h2 className="font-medium text-xl">Acknowledgement</h2>
        These are the Terms and Conditions governing the use of this Service and
        the agreement that operates between You and the Authors. These Terms and
        Conditions set out the rights and obligations of all users regarding the
        use of the Service.
        <br />
        Your access to and use of the Service is conditioned on Your acceptance
        of and compliance with these Terms and Conditions. These Terms and
        Conditions apply to all visitors, users and others who access or use the
        Service.
        <br />
        By accessing or using the Service You agree to be bound by these Terms
        and Conditions. If You disagree with any part of these Terms and
        Conditions then You may not access the Service.
        <br />
        <h2 className="font-medium text-xl">Software Application</h2>
        We may include software for use in connection with our services and
        application. Our application is accompanied by a Creative Commons
        Attribution-NonCommercial-NoDerivatives 4.0 International license.
        Information on the license can be found here:
        <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/">
          https://creativecommons.org/licenses/by-nc-nd/4.0/
        </a>
        <h2 className="font-medium text-xl">Links to External Websites</h2>
        Our Application and Service may contain links to third-party web sites
        or require usage of software or services that are not owned or
        controlled by the Author(s). The Author(s) has no control over, and
        assumes no responsibility for, the content, privacy policies, or
        practices of any third party web sites or services. You further
        acknowledge and agree that the Author(s) shall not be responsible or
        liable, directly or indirectly, for any damage or loss caused or alleged
        to be caused by or in connection with the use of or reliance on any such
        content, goods or services available on or through any such web sites or
        services. We strongly advise You to read the terms and conditions and
        privacy policies of any third-party web sites or services that You
        visit. This includes and is not limited to Whatsapp, and its underlying
        services, which are used by the Author(s). Links to the terms of use and
        service website are as follows:
        <ul>
          <li>
            Terms of Service: https://www.whatsapp.com/legal/terms-of-service
          </li>
          <li>
            BuildingTransparency APIs Terms of Service:
            https://www.buildingtransparency.org/ec3-resources/buildingtransparency-apis-terms-service/
          </li>
        </ul>
        <h2 className="font-medium text-xl">Disclaimer</h2>
        “Use at Your Own Risk” The Author(s) assumes no responsibility for
        errors or omissions in the contents of the Service and Application. In
        no event shall the Author(s) be liable for any special, direct,
        indirect, consequential, or incidental damages or any damages
        whatsoever, whether in an action of contract, negligence or other tort,
        arising out of or in connection with the use of the Service or the
        contents of the Service. The Author(s) reserve the right to make
        additions, deletions, or modifications to the contents of the
        Service/Application at any time without prior notice. The Group does not
        warrant that the Service/Application is free of viruses or other harmful
        components. All information in the Service/Application is provided “as
        is”, with no guarantee of completeness, accuracy, timeliness or of the
        results obtained from the use of this information, and without warranty
        of any kind, express or implied, including, but not limited to
        warranties of performance, merchantability and fitness for a particular
        purpose.
        <h2 className="font-medium text-xl">Intellectual Property Rights</h2>
        Unless otherwise indicated, the Service and Application is our (the
        Author(s)'s) proprietary property and all source code, databases,
        functionality, software, website designs, audio, video, text,
        photographs, and graphics on the Site or in the Application
        (collectively, the “Content”) and the trademarks, service marks, and
        logos contained therein (the “Marks”) are owned or controlled by Us or
        licensed to Us, and are protected by copyright and trademark laws and
        various other intellectual property rights and unfair competition laws
        of the United States, international copyright laws, and international
        conventions. The Content and the Marks are provided on the Site “AS IS”
        for Your information and personal use only. Except as expressly provided
        in these Terms and Conditions, no part of the Site and no Content or
        Marks may be copied, reproduced, aggregated, republished, uploaded,
        posted, publicly displayed, encoded, translated, transmitted,
        distributed, sold, licensed, or otherwise exploited for any commercial
        purpose whatsoever, without our express prior written permission.
        <h2 className="font-medium text-xl">Prohibited Activities</h2>
        The Application may not be used in connection with any commercial
        endeavors except those that are specifically endorsed or approved by us.
        As a user of the Application, You agree not to:
        <ul>
          <li>
            {" "}
            Use the Application as part of any effort to compete with us or
            otherwise use the Application and/or the Content for any
            revenue-generating endeavor or commercial enterprise.
          </li>
          <li>
            Decipher, decompile, disassemble, or reverse engineer any of the
            software comprising or in any way making up a part of the
            Application.
          </li>
          <li>
            Copy or adapt the Application and Author’s content, including but
            not limited to HTML, JavaScript or other code.
          </li>
          <li>
            Circumvent, disable, or otherwise interfere with security-related
            features of the Application, including features that prevent or
            restrict the use or copying of any Content or enforce limitations on
            the use of the Application and/or the Content contained therein.
          </li>
          <li>
            {" "}
            Attempt to bypass any measures of the Application designed to
            prevent or restrict access to the Application, or any portion of the
            Application.
          </li>
          <li>
            Delete the copyright or other proprietary rights notice from any
            Content.
          </li>
          <li>
            Disparage, tarnish, or otherwise harm, in our opinion, Us and/or the
            Application.
          </li>
          <li>
            Use the Application in a manner inconsistent with any applicable
            laws or regulations.
          </li>
        </ul>
        <h2 className="font-medium text-xl">Disputes Resolution</h2>
        If You have any concern or dispute about the Service or Application, You
        agree to first try to resolve the dispute informally by contacting the
        Authors. United States Legal Compliance You represent and warrant that
        (i) You are not located in a country that is subject to the United
        States government embargo, or that has been designated by the United
        States government as a “terrorist supporting” country, and (ii) You are
        not listed on any United States government list of prohibited or
        restricted parties.
        <h2 className="font-medium text-xl">Contact Us</h2>
        If You have any questions about these Terms and Conditions, You can
        contact Us:
        <a href="mailto:ssanghvi@andrew.cmu.edu">ssanghvi@andrew.cmu.edu</a>
        <h2 className="font-medium text-xl">PRIVACY NOTICE</h2>
        Thank you for choosing to be part of our community at Pittsburgh2Peers
        ("Company," "we," "us," or "our"). We are committed to protecting your
        personal information and your right to privacy. If you have any
        questions or concerns about this privacy notice or our practices with
        regard to your personal information, please contact us at{" "}
        <a href="mailto:ssanghvi@andrew.cmu.edu">ssanghvi@andrew.cmu.edu</a>.
        This privacy notice describes how we might use your information if you:
        <ul>
          <li>
            Visit our website at{" "}
            <a href="https://pittsburgh2peers.vercel.app/">
              pittsburgh2peers.vercel.app{" "}
            </a>
          </li>
          <li>
            Engage with us in other related ways ― including any sales,
            marketing, or events
          </li>
        </ul>
        In this privacy notice, if we refer to:
        <ul>
          <li>
            "Website," we are referring to any website of ours that links to
            this policy
          </li>
          <li>
            "Services," we are referring to our Website, and other related
            services, including any sales, marketing, or events
          </li>
        </ul>
        The purpose of this privacy notice is to explain to you in the clearest
        way possible what information we collect, how we use it, and what rights
        you have in relation to it. If there are any terms in this privacy
        notice that you do not agree with, please discontinue use of our
        Services immediately.
        <b>
          The purpose of this privacy notice is to explain to you in the
          clearest way possible what information we collect, how we use it, and
          what rights you have in relation to it. If there are any terms in this
          privacy notice that you do not agree with, please discontinue use of
          our Services immediately.
        </b>
        <h2 className="font-medium text-xl">TABLE OF CONTENTS</h2>
        <ol>
          <li>WHAT INFORMATION DO WE COLLECT?</li>
          <li>HOW DO WE USE YOUR INFORMATION?</li>
          <li>WILL YOUR INFORMATION BE SHARED WITH ANYONE?</li>
          <li>DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</li>
          <li>IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?</li>
          <li>HOW LONG DO WE KEEP YOUR INFORMATION?</li>
          <li>HOW DO WE KEEP YOUR INFORMATION SAFE?</li>
          <li>WHAT ARE YOUR PRIVACY RIGHTS?</li>
          <li>CONTROLS FOR DO-NOT-TRACK FEATURES</li>
          <li>DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</li>
          <li>DO WE MAKE UPDATES TO THIS NOTICE?</li>
          <li>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</li>
          <li>
            HOW CAN YOU REVIEW, UPDATE OR DELETE THE DATA WE COLLECT FROM YOU?
          </li>
        </ol>
        <h2 className="font-medium text-xl">
          1. WHAT INFORMATION DO WE COLLECT?
        </h2>
        <b>Personal information you disclose to us</b>
        In Short: We collect personal information that you provide to us.
        <br />
        We collect personal information that you voluntarily provide to us when
        you express an interest in obtaining information about us or our
        products and Services, when you participate in activities on the Website
        or otherwise when you contact us. The personal information that we
        collect depends on the context of your interactions with us and the
        Website, the choices you make and the products and features you use. The
        personal information we collect may include the following:
        <br />
        Personal Information Provided by You. We collect names, email addresses;
        job titles, contact preferences, phone numbers, and other similar
        information. All personal information that you provide to us must be
        true, complete and accurate, and you must notify us of any changes to
        such personal information.
        <h2 className="font-medium text-xl">
          Information automatically collected
        </h2>
        In Short: Some information — such as your Internet Protocol (IP) address
        and/or browser and device characteristics — is collected automatically
        when you visit our Website.
        <br />
        We automatically collect certain information when you visit, use or
        navigate the Website. This information does not reveal your specific
        identity (like your name or contact information) but may include device
        and usage information, such as your IP address, browser and device
        characteristics, operating system, language preferences, referring URLs,
        device name, country, location, information about how and when you use
        our Website and other technical information. This information is
        primarily needed to maintain the security and operation of our Website,
        and for our internal analytics and reporting purposes. Like many
        businesses, we also collect information through cookies and similar
        technologies.
        <br />
        The information we collect includes:
        <ul>
          <li>
            Log and Usage Data. Log and usage data is service-related,
            diagnostic, usage and performance information our servers
            automatically collect when you access or use our Website and which
            we record in log files. Depending on how you interact with us, this
            log data may include your IP address, device information, browser
            type and settings and information about your activity in the Website
            (such as the date/time stamps associated with your usage, pages and
            files viewed, searches and other actions you take such as which
            features you use), device event information (such as system
            activity, error reports (sometimes called 'crash dumps') and
            hardware settings).
          </li>
        </ul>
        <h2 className="font-medium text-xl">
          2. HOW DO WE USE YOUR INFORMATION?
        </h2>
        <b>
          In Short: We process your information for purposes based on legitimate
          business interests, the fulfillment of our contract with you,
          compliance with our legal obligations, and/or your consent.
        </b>
        We use personal information collected via our Website for a variety of
        business purposes described below. We process your personal information
        for these purposes in reliance on our legitimate business interests, in
        order to enter into or perform a contract with you, with your consent,
        and/or for compliance with our legal obligations. We indicate the
        specific processing grounds we rely on next to each purpose listed
        below.
        <br />
        We use the information we collect or receive:
        <ol>
          <li>
            To send administrative information to you. We may use your personal
            information to send you product, service and new feature information
            and/or information about changes to our terms, conditions, and
            policies.
          </li>
          <li>
            To protect our Services. We may use your information as part of our
            efforts to keep our Website safe and secure (for example, for fraud
            monitoring and prevention).
          </li>
          <li>
            To enforce our terms, conditions and policies for business purposes,
            to comply with legal and regulatory requirements or in connection
            with our contract.
          </li>
          <li>
            To respond to legal requests and prevent harm. If we receive a
            subpoena or other legal request, we may need to inspect the data we
            hold to determine how to respond.
          </li>
          <li>
            Fulfill and manage your orders. We may use your information to
            fulfill and manage your orders, payments, returns, and exchanges
            made through the Website.
          </li>
          <li>
            Administer prize draws and competitions. We may use your information
            to administer prize draws and competitions when you elect to
            participate in our competitions.
          </li>
          <li>
            To deliver and facilitate delivery of services to the user. We may
            use your information to provide you with the requested service.
          </li>
          <li>
            To respond to user inquiries/offer support to users. We may use your
            information to respond to your inquiries and solve any potential
            issues you might have with the use of our Services.
          </li>
          <li>
            To send you marketing and promotional communications. We and/or our
            third-party marketing partners may use the personal information you
            send to us for our marketing purposes, if this is in accordance with
            your marketing preferences. For example, when expressing an interest
            in obtaining information about us or our Website, subscribing to
            marketing or otherwise contacting us, we will collect personal
            information from you. You can opt-out of our marketing emails at any
            time (see the "WHAT ARE YOUR PRIVACY RIGHTS?" below).
          </li>
          <li>
            Deliver targeted advertising to you. We may use your information to
            develop and display personalized content and advertising (and work
            with third parties who do so) tailored to your interests and/or
            location and to measure its effectiveness.
          </li>
          <li>
            For other business purposes. We may use your information for other
            business purposes, such as data analysis, identifying usage trends,
            determining the effectiveness of our promotional campaigns and to
            evaluate and improve our Website, products, marketing and your
            experience. We may use and store this information in aggregated and
            anonymized form so that it is not associated with individual end
            users and does not include personal information. We will not use
            identifiable personal information without your consent.
          </li>
        </ol>
        <h2 className="font-medium text-xl">
          3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?
        </h2>
        In Short: We only share information with your consent, to comply with
        laws, to provide you with services, to protect your rights, or to
        fulfill business obligations.
        <br />
        We may process or share your data that we hold based on the following
        legal basis:
        <ol>
          <li>
            Consent: We may process your data if you have given us specific
            consent to use your personal information for a specific purpose.
          </li>
          <li>
            Legitimate Interests: We may process your data when it is reasonably
            necessary to achieve our legitimate business interests.
          </li>
          <li>
            Performance of a Contract: Where we have entered into a contract
            with you, we may process your personal information to fulfill the
            terms of our contract.
          </li>
          <li>
            Legal Obligations: We may disclose your information where we are
            legally required to do so in order to comply with applicable law,
            governmental requests, a judicial proceeding, court order, or legal
            process, such as in response to a court order or a subpoena
            (including in response to public authorities to meet national
            security or law enforcement requirements).
          </li>
          <li>
            Vital Interests: We may disclose your information where we believe
            it is necessary to investigate, prevent, or take action regarding
            potential violations of our policies, suspected fraud, situations
            involving potential threats to the safety of any person and illegal
            activities, or as evidence in litigation in which we are involved.
          </li>
          <li>
            More specifically, we may need to process your data or share your
            personal information in the following situations:
          </li>
          <li>
            Business Transfers: We may share or transfer your information in
            connection with, or during negotiations of, any merger, sale of
            company assets, financing, or acquisition of all or a portion of our
            business to another company.
          </li>
          <li>
            Affiliates: We may share your information with our affiliates, in
            which case we will require those affiliates to honor this privacy
            notice. Affiliates include our parent company and any subsidiaries,
            joint venture partners or other companies that we control or that
            are under common control with us.
          </li>
          <li>
            Business Partners: We may share your information with our business
            partners to offer you certain products, services or promotions.
          </li>
        </ol>
        <h2 className="font-medium text-xl">
          4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
        </h2>
        In Short: We may use cookies and other tracking technologies to collect
        and store your information.
        <br />
        We may use cookies and similar tracking technologies (like web beacons
        and pixels) to access or store information. Specific information about
        how we use such technologies and how you can refuse certain cookies is
        set out in our Cookie Notice.
        <h2 className="font-medium text-xl">
          5. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
        </h2>
        In Short: We may transfer, store, and process your information in
        countries other than your own.
        <br />
        Our servers are located in the United States and India. If you are
        accessing our Website from outside the United States or India, please be
        aware that your information may be transferred to, stored, and processed
        by us in our facilities and by those third parties with whom we may
        share your personal information (see "WILL YOUR INFORMATION BE SHARED
        WITH ANYONE?" above), in the United States, and other countries.
        <h2 className="font-medium text-xl">
          6. HOW LONG DO WE KEEP YOUR INFORMATION?
        </h2>
        In Short: We keep your information for as long as necessary to fulfill
        the purposes outlined in this privacy notice unless otherwise required
        by law.
        <br />
        We will only keep your personal information for as long as it is
        necessary for the purposes set out in this privacy notice, unless a
        longer retention period is required or permitted by law (such as tax,
        accounting or other legal requirements). No purpose in this notice will
        require us keeping your personal information for longer than 90 days.
        When we have no ongoing legitimate business need to process your
        personal information, we will either delete or anonymize such
        information, or, if this is not possible (for example, because your
        personal information has been stored in backup archives), then we will
        securely store your personal information and isolate it from any further
        processing until deletion is possible.
        <h2 className="font-medium text-xl">
          7. HOW DO WE KEEP YOUR INFORMATION SAFE?
        </h2>
        In Short: We aim to protect your personal information through a system
        of organizational and technical security measures.
        <br />
        We have implemented appropriate technical and organizational security
        measures designed to protect the security of any personal information we
        process. However, despite our safeguards and efforts to secure your
        information, no electronic transmission over the Internet or information
        storage technology can be guaranteed to be 100% secure, so we cannot
        promise or guarantee that hackers, cybercriminals, or other unauthorized
        third parties will not be able to defeat our security, and improperly
        collect, access, steal, or modify your information. Although we will do
        our best to protect your personal information, transmission of personal
        information to and from our Website is at your own risk. You should only
        access the Website within a secure environment.
        <h2 className="font-medium text-xl">
          8. WHAT ARE YOUR PRIVACY RIGHTS?
        </h2>
        Cookies and similar technologies: Most Web browsers are set to accept
        cookies by default. If you prefer, you can usually choose to set your
        browser to remove cookies and to reject cookies. If you choose to remove
        cookies or reject cookies, this could affect certain features or
        services of our Website. To opt-out of interest-based advertising by
        advertisers on our Website visit http://www.aboutads.info/choices/.
        <h2 className="font-medium text-xl">
          9. CONTROLS FOR DO-NOT-TRACK FEATURES
        </h2>
        Most web browsers and some mobile operating systems and mobile
        applications include a Do-Not-Track ("DNT") feature or setting you can
        activate to signal your privacy preference not to have data about your
        online browsing activities monitored and collected. At this stage no
        uniform technology standard for recognizing and implementing DNT signals
        has been finalized. As such, we do not currently respond to DNT browser
        signals or any other mechanism that automatically communicates your
        choice not to be tracked online. If a standard for online tracking is
        adopted that we must follow in the future, we will inform you about that
        practice in a revised version of this privacy notice.
        <h2 className="font-medium text-xl">
          10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
        </h2>
        In Short: Yes, if you are a resident of California, you are granted
        specific rights regarding access to your personal information.
        <br />
        California Civil Code Section 1798.83, also known as the "Shine The
        Light" law, permits our users who are California residents to request
        and obtain from us, once a year and free of charge, information about
        categories of personal information (if any) we disclosed to third
        parties for direct marketing purposes and the names and addresses of all
        third parties with which we shared personal information in the
        immediately preceding calendar year. If you are a California resident
        and would like to make such a request, please submit your request in
        writing to us using the contact information provided below. If you are
        under 18 years of age, reside in California, and have a registered
        account with the Website, you have the right to request removal of
        unwanted data that you publicly post on the Website. To request removal
        of such data, please contact us using the contact information provided
        below, and include the email address associated with your account and a
        statement that you reside in California. We will make sure the data is
        not publicly displayed on the Website, but please be aware that the data
        may not be completely or comprehensively removed from all our systems
        (e.g. backups, etc.).
        <h2 className="font-medium text-xl">CCPA Privacy Notice</h2>
        <ol>
          <li>
            every individual who is in the State of California for other than a
            temporary or transitory purpose and
          </li>
          <li>
            every individual who is domiciled in the State of California who is
            outside the State of California for a temporary or transitory
            purpose
          </li>
        </ol>
        All other individuals are defined as "non-residents."
        <br />
        If this definition of "resident" applies to you, we must adhere to
        certain rights and obligations regarding your personal information.
        <h3>What categories of personal information do we collect?</h3>
        We have collected the following categories of personal information in
        the past twelve (12) months:
        <table className="min-w-full border-collapse border border-gray-200">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2">Category</th>
              <th className="border border-gray-300 p-2">Examples</th>
              <th className="border border-gray-300 p-2">Collected</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 p-2">A. Identifiers</td>
              <td className="border border-gray-300 p-2">
                Contact details, such as real name, alias, postal address,
                telephone or mobile contact number, unique personal identifier,
                online identifier, Internet Protocol address, email address and
                account name
              </td>
              <td className="border border-gray-300 p-2">YES</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                B. Personal information categories listed in the California
                Customer Records statute
              </td>
              <td className="border border-gray-300 p-2">
                Name, contact information, education, employment, employment
                history and financial information
              </td>
              <td className="border border-gray-300 p-2">YES</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                C. Protected classification characteristics under California or
                federal law
              </td>
              <td className="border border-gray-300 p-2">
                Gender and date of birth
              </td>
              <td className="border border-gray-300 p-2">NO</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                D. Commercial information
              </td>
              <td className="border border-gray-300 p-2">
                Transaction information, purchase history, financial details and
                payment information
              </td>
              <td className="border border-gray-300 p-2">NO</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                E. Biometric information
              </td>
              <td className="border border-gray-300 p-2">
                Fingerprints and voiceprints
              </td>
              <td className="border border-gray-300 p-2">NO</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                F. Internet or other similar network activity
              </td>
              <td className="border border-gray-300 p-2">
                Browsing history, search history, online behavior, interest
                data, and interactions with our and other websites,
                applications, systems and advertisements
              </td>
              <td className="border border-gray-300 p-2">NO</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                G. Geolocation data
              </td>
              <td className="border border-gray-300 p-2">Device location</td>
              <td className="border border-gray-300 p-2">NO</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                H. Audio, electronic, visual, thermal, olfactory, or similar
                information
              </td>
              <td className="border border-gray-300 p-2">
                Images and audio, video or call recordings created in connection
                with our business activities
              </td>
              <td className="border border-gray-300 p-2">NO</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                I. Professional or employment-related information
              </td>
              <td className="border border-gray-300 p-2">
                Business contact details in order to provide you our services at
                a business level, job title as well as work history and
                professional qualifications if you apply for a job with us
              </td>
              <td className="border border-gray-300 p-2">NO</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                J. Education Information
              </td>
              <td className="border border-gray-300 p-2">
                Student records and directory information
              </td>
              <td className="border border-gray-300 p-2">NO</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                K. Inferences drawn from other personal information
              </td>
              <td className="border border-gray-300 p-2">
                Inferences drawn from any of the collected personal information
                listed above to create a profile or summary about, for example,
                an individual’s preferences and characteristics
              </td>
              <td className="border border-gray-300 p-2">YES</td>
            </tr>
          </tbody>
        </table>
        We may also collect other personal information outside of these
        categories instances where you interact with us in-person, online, or by
        phone or mail in the context of:
        <ol>
          <li>Receiving help through our customer support channels;</li>
          <li>Participation in customer surveys or contests;</li>
          <li>
            Facilitation in the delivery of our Services and to respond to your
            inquiries.
          </li>
        </ol>
        <h2 className="font-medium text-xl">
          How do we use and share your personal information?
        </h2>
        More information about our data collection and sharing practices can be
        found in this privacy notice. You may contact us by email at
        ssanghvi@andrew.cmu.edu, by visiting
        https://pittsburgh2peers.vercel.app/, or by referring to the contact
        details at the bottom of this document. If you are using an authorized
        agent to exercise your right to opt-out we may deny a request if the
        authorized agent does not submit proof that they have been validly
        authorized to act on your behalf.
        <h2 className="font-medium text-xl">
          Will your information be shared with anyone else?
        </h2>
        We may disclose your personal information with our service providers
        pursuant to a written contract between us and each service provider.
        Each service provider is a for-profit entity that processes the
        information on our behalf. We may use your personal information for our
        own business purposes, such as for undertaking internal research for
        technological development and demonstration. This is not considered to
        be "selling" your personal data. Pittsburgh2Peers has not disclosed or
        sold any personal information to third parties for a business or
        commercial purpose in the preceding 12 months. Pittsburgh2Peers will not
        sell personal information in the future belonging to website visitors,
        users and other consumers.
        <h2 className="font-medium text-xl">
          Your rights with respect to your personal data
        </h2>
        <div className="underline">
          Right to request deletion of the data - Request to delete
        </div>
        You can ask for the deletion of your personal information. If you ask us
        to delete your personal information, we will respect your request and
        delete your personal information, subject to certain exceptions provided
        by law, such as (but not limited to) the exercise by another consumer of
        his or her right to free speech, our compliance requirements resulting
        from a legal obligation or any processing that may be required to
        protect against illegal activities.
        <br />
        <div className="underline">Right to be informed - Request to know</div>
        Depending on the circumstances, you have a right to know:
        <ul>
          <li>whether we collect and use your personal information;</li>
          <li>the categories of personal information that we collect;</li>
          <li>
            the purposes for which the collected personal information is used;
          </li>
          <li>whether we sell your personal information to third parties;</li>
          <li>
            the categories of personal information that we sold or disclosed for
            a business purpose;
          </li>
          <li>
            the categories of third parties to whom the personal information was
            sold or disclosed for a business purpose;
          </li>
          <li>
            the business or commercial purpose for collecting or selling
            personal information.
          </li>
        </ul>
        In accordance with applicable law, we are not obligated to provide or
        delete consumer information that is de-identified in response to a
        consumer request or to re-identify individual data to verify a consumer
        request.
        <div className="underline">
          Right to Non-Discrimination for the Exercise of a Consumer’s Privacy
          Rights
        </div>
        We will not discriminate against you if you exercise your privacy
        rights.
        <div className="underline">Verification process</div>
        Upon receiving your request, we will need to verify your identity to
        determine you are the same person about whom we have the information in
        our system. These verification efforts require us to ask you to provide
        information so that we can match it with information you have previously
        provided us. For instance, depending on the type of request you submit,
        we may ask you to provide certain information so that we can match the
        information you provide with the information we already have on file, or
        we may contact you through a communication method (e.g. phone or email)
        that you have previously provided to us. We may also use other
        verification methods as the circumstances dictate. We will only use
        personal information provided in your request to verify your identity or
        authority to make the request. To the extent possible, we will avoid
        requesting additional information from you for the purposes of
        verification. If, however, we cannot verify your identity from the
        information already maintained by us, we may request that you provide
        additional information for the purposes of verifying your identity, and
        for security or fraud-prevention purposes. We will delete such
        additionally provided information as soon as we finish verifying you.
        <div className="underline">Other privacy rights</div>
        <ul>
          <li>you may object to the processing of your personal data;</li>
          <li>
            you may request correction of your personal data if it is incorrect
            or no longer relevant, or ask to restrict the processing of the
            data;
          </li>
          <li>
            you can designate an authorized agent to make a request under the
            CCPA on your behalf. We may deny a request from an authorized agent
            that does not submit proof that they have been validly authorized to
            act on your behalf in accordance with the CCPA;
          </li>
          <li>
            you may request to opt-out from future selling of your personal
            information to third parties. Upon receiving a request to opt-out,
            we will act upon the request as soon as feasibly possible, but no
            later than 15 days from the date of the request submission.
          </li>
        </ul>
        To exercise these rights, you can contact us by email at
        ssanghvi@andrew.cmu.edu, by visiting
        https://pittsburgh2peers.vercel.app/, or by referring to the contact
        details at the bottom of this document. If you have a complaint about
        how we handle your data, we would like to hear from you.
        <h2 className="font-medium text-xl">
          11. DO WE MAKE UPDATES TO THIS NOTICE?
        </h2>
        In Short: Yes, we will update this notice as necessary to stay compliant
        with relevant laws. We may update this privacy notice from time to time.
        The updated version will be indicated by an updated "Revised" date and
        the updated version will be effective as soon as it is accessible. If we
        make material changes to this privacy notice, we may notify you either
        by prominently posting a notice of such changes or by directly sending
        you a notification. We encourage you to review this privacy notice
        frequently to be informed of how we are protecting your information.
        <h2 className="font-medium text-xl">
          12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
        </h2>
        If you have questions or comments about this notice, you may contact our
        Data Protection Officer (DPO), Shreyas Sanghvi, by email at
        shsanghv@andrew.cmu.edu:
        <h2 className="font-medium text-xl">
          13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
          YOU?{" "}
        </h2>
        Based on the applicable laws of your country, you may have the right to
        request access to the personal information we collect from you, change
        that information, or delete it in some circumstances. To request to
        review, update, or delete your personal information, please submit a
        request form by clicking{" "}
        <a href="http://https://app.termly.io/notify/2ba378e9-8d5b-4cb1-acbf-2b79fc6b0880">
          here
        </a>
        . This privacy policy was created using{" "}
        <a href="http://https://termly.io/products/privacy-policy-generator/?ftseo">
          Termly's Privacy Policy Generator.
        </a>
        <h2 className="font-medium text-xl">COOKIE POLICY</h2>
        <p>Last updated Jul 19, 2024</p>
        This Cookie Policy explains how Pittsburgh2Peers ("Company", "we", "us",
        and "our") uses cookies and similar technologies to recognize you when
        you visit our websites at https://pittsburgh2peers.vercel.app
        ("Websites"). It explains what these technologies are and why we use
        them, as well as your rights to control our use of them. In some cases
        we may use cookies to collect personal information, or that becomes
        personal information if we combine it with other information.
        <h3>What are cookies?</h3>
        Cookies are small data files that are placed on your computer or mobile
        device when you visit a website. Cookies are widely used by website
        owners in order to make their websites work, or to work more
        efficiently, as well as to provide reporting information. Cookies set by
        the website owner (in this case, Pittsburgh2Peers) are called "first
        party cookies". Cookies set by parties other than the website owner are
        called "third party cookies". Third party cookies enable third party
        features or functionality to be provided on or through the website (e.g.
        like advertising, interactive content and analytics). The parties that
        set these third party cookies can recognize your computer both when it
        visits the website in question and also when it visits certain other
        websites.
        <h3>Why do we use cookies?</h3>
        We use first and third party cookies for several reasons. Some cookies
        are required for technical reasons in order for our Websites to operate,
        and we refer to these as "essential" or "strictly necessary" cookies.
        Other cookies also enable us to track and target the interests of our
        users to enhance the experience on our Online Properties. Third parties
        serve cookies through our Websites for advertising, analytics and other
        purposes. This is described in more detail below. The specific types of
        first and third party cookies served through our Websites and the
        purposes they perform are described below (please note that the specific
        cookies served may vary depending on the specific Online Properties you
        visit):
        <h3>How can I control cookies?</h3>
        You have the right to decide whether to accept or reject cookies. You
        can exercise your cookie rights by setting your preferences in the
        Cookie Consent Manager. The Cookie Consent Manager allows you to select
        which categories of cookies you accept or reject. Essential cookies
        cannot be rejected as they are strictly necessary to provide you with
        services. The Cookie Consent Manager can be found in the notification
        banner and on our website. If you choose to reject cookies, you may
        still use our website though your access to some functionality and areas
        of our website may be restricted. You may also set or amend your web
        browser controls to accept or refuse cookies. As the means by which you
        can refuse cookies through your web browser controls vary from
        browser-to-browser, you should visit your browser's help menu for more
        information. The specific types of first and third party cookies served
        through our Websites and the purposes they perform are described in the
        table below (please note that the specific cookies served may vary
        depending on the specific Online Properties you visit):
        <h3>Mixpanel Cookies</h3>
        These cookies are strictly necessary to provide you with services
        available through our Websites and to use some of its features, such as
        access to secure areas.
        <table className="border border-gray-300">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2">Provider</th>
              <td className="border border-gray-300 p-2">mixpanel.com</td>
            </tr>
            <tr>
              <th className="border border-gray-300 p-2">Name</th>
              <td className="border border-gray-300 p-2">__mixpanel</td>
            </tr>
            <tr>
              <th className="border border-gray-300 p-2">Service</th>
              <td className="border border-gray-300 p-2">Mixpanel Analytics</td>
            </tr>
            <tr>
              <th className="border border-gray-300 p-2">Purpose</th>
              <td className="border border-gray-300 p-2">
                Used to track user interactions and events on the website.
              </td>
            </tr>
            <tr>
              <th className="border border-gray-300 p-2">Expires in</th>
              <td className="border border-gray-300 p-2">2 years</td>
            </tr>
            <tr>
              <th className="border border-gray-300 p-2">Type</th>
              <td className="border border-gray-300 p-2">http_cookie</td>
            </tr>
            <tr>
              <th className="border border-gray-300 p-2">Country</th>
              <td className="border border-gray-300 p-2">United States</td>
            </tr>
          </thead>
        </table>
        <h3>What about other tracking technologies, like web beacons?</h3>
        Cookies are not the only way to recognize or track visitors to a
        website. We may use other, similar technologies from time to time, like
        web beacons (sometimes called "tracking pixels" or "clear gifs"). These
        are tiny graphics files that contain a unique identifier that enable us
        to recognize when someone has visited our Websites or opened an e-mail
        including them. This allows us, for example, to monitor the traffic
        patterns of users from one page within a website to another, to deliver
        or communicate with cookies, to understand whether you have come to the
        website from an online advertisement displayed on a third-party website,
        to improve site performance, and to measure the success of e-mail
        marketing campaigns. In many instances, these technologies are reliant
        on cookies to function properly, and so declining cookies will impair
        their functioning.
        <h3>Do you use Flash cookies or Local Shared Objects?</h3>
        Websites may also use so-called "Flash Cookies" (also known as Local
        Shared Objects or "LSOs") to, among other things, collect and store
        information about your use of our services, fraud prevention and for
        other site operations. If you do not want Flash Cookies stored on your
        computer, you can adjust the settings of your Flash player to block
        Flash Cookies storage using the tools contained in the Website Storage
        Settings Panel. You can also control Flash Cookies by going to the
        Global Storage Settings Panel and following the instructions (which may
        include instructions that explain, for example, how to delete existing
        Flash Cookies (referred to "information" on the Macromedia site), how to
        prevent Flash LSOs from being placed on your computer without your being
        asked, and (for Flash Player 8 and later) how to block Flash Cookies
        that are not being delivered by the operator of the page you are on at
        the time). Please note that setting the Flash Player to restrict or
        limit acceptance of Flash Cookies may reduce or impede the functionality
        of some Flash applications, including, potentially, Flash applications
        used in connection with our services or online content.
        <h3>Do you serve targeted advertising?</h3>
        Third parties may serve cookies on your computer or mobile device to
        serve advertising through our Websites. These companies may use
        information about your visits to this and other websites in order to
        provide relevant advertisements about goods and services that you may be
        interested in. They may also employ technology that is used to measure
        the effectiveness of advertisements. This can be accomplished by them
        using cookies or web beacons to collect information about your visits to
        this and other sites in order to provide relevant advertisements about
        goods and services of potential interest to you. The information
        collected through this process does not enable them or us to identify
        your name, contact details or other details that directly identify you
        unless you choose to provide these.
        <h3>How often will you update this Cookie Policy?</h3>
        We may update this Cookie Policy from time to time in order to reflect,
        for example, changes to the cookies we use or for other operational,
        legal or regulatory reasons. Please, therefore, re-visit this Cookie
        Policy regularly to stay informed about our use of cookies and related
        technologies. The date at the top of this Cookie Policy indicates when
        it was last updated.
        <h3>Where can I get further information?</h3>
        If you have any questions about our use of cookies or other
        technologies, please email us at ssanghvi@andrew.cmu.edu.
        <div className="h-10"></div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
